/**
 * MGM v1 · the values the browser shares with the server.
 *
 * The server decides everything (docs/MGM_ESCOPO_FUNCIONAL.md, section 2.2). These
 * copies exist only so the signup form can show the code the link applied and send
 * a closed "Como conheceu?" answer. Sources of truth:
 *   supabase/pending/mgm_01_estrutura.sql  domain acq_code, acq_office_attribution.self_reported
 *   supabase/pending/mgm_02_funcoes.sql    acq_normalize_code, the 90-day lookback
 * src/__tests__/acquisition.test.ts fails when they drift.
 */

/** No 0, O, 1 or I. */
export const ACQ_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
export const ACQ_CODE_RE = /^[A-HJ-NP-Z2-9]{8}$/

/** Arrivals count for the 90 days before the office is created. */
export const ACQ_LOOKBACK_DAYS = 90

/** Only these query parameters start a capture. Nothing else is tracked. */
export const ACQ_CAPTURE_PARAMS = ['ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const

/** Closed list for "Como conheceu?". The answer never becomes a referral. */
export const ACQ_SELF_REPORTED = ['office_referral', 'partner_referral', 'event', 'search', 'social', 'other'] as const
export type AcqSelfReported = (typeof ACQ_SELF_REPORTED)[number]

/** Same rule as public.acq_normalize_code: "k7m2-q9xa", "K7M2 Q9XA" and "K7M2Q9XA" are one code. */
export function normalizeAcqCode(raw: string | null | undefined): string | null {
  const v = (raw ?? '').replace(/[\s-]/g, '').toUpperCase()
  return ACQ_CODE_RE.test(v) ? v : null
}

/** Reading form, XXXX-XXXX, like public.acq_display_code. */
export function displayAcqCode(code: string): string {
  return `${code.slice(0, 4)}-${code.slice(4, 8)}`
}
